import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectAgreementPage } from './select-agreement';

@NgModule({
  declarations: [
    SelectAgreementPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectAgreementPage),
  ],
})
export class SelectAgreementPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-agreement/select-agreement.module.ts